import React, { useContext } from "react";
import { AppContext } from "../Index";
import FoodItem from "./FoodItem";
const FamilySubGroup = ({ familyGroup }) => {
  const { selectedFamilySubGroup, setSelectedFamilySubGroup } =
    useContext(AppContext);

  return (
    <div className="accordion-item" key={familyGroup.itemCode}>
      <h2 className="accordion-header" id="headingOne">
        <button
          className={`accordion-button ${selectedFamilySubGroup === familyGroup.itemCode ? "" : "collapsed"
            }`}
          type="button"
          data-bs-toggle="collapse"
          // data-bs-target={`#${familyGroup.itemCode}`}
          aria-expanded="true"
          aria-controls={`${familyGroup.itemCode}`}
          onClick={(ev) => {
            setSelectedFamilySubGroup(
              selectedFamilySubGroup === familyGroup.itemCode
                ? null
                : familyGroup.itemCode,
            );
          }}
        >
          {familyGroup.name}
        </button>
      </h2>
      <div
        id={`${familyGroup.itemCode}`}
        className={`accordion-collapse collapse ${selectedFamilySubGroup === familyGroup.itemCode ? "show" : ""
          }`}
        aria-labelledby="headingOne"
        data-bs-parent={`${familyGroup.itemCode}`}
      >
        <div className="accordion-body">
          {familyGroup.menuItem?.map((mi) => {
            return <FoodItem menuItem={mi} key={mi.itemCode} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default FamilySubGroup;
